import { Thumb } from '@design-system/components/molecules'
import { colors, elevation } from '@design-system/styles'
import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import s3URL from '@mathflat/common/util/s3'
import { observer } from 'mobx-react'
import { _Badge } from 'src/component/atoms/Badge'
import type { SubScenario } from 'src/dto'

import { scenarioService } from '@/service/scenario.service'

const SubScenarioCard = ({ subScenario }: { subScenario: SubScenario }) => {
  return (
    <S.ScenarioCard
      onClick={() => {
        scenarioService.toggleSubScenarioHandler(subScenario.id)
      }}
    >
      <div className="inner">
        <div className="row">
          <_Badge className="badge" color="#fff" background={colors.subYellow}>
            더 알아보고 싶어요!
          </_Badge>
        </div>
        <div className="row">
          <strong className="title">{subScenario.title}</strong>
        </div>
        <div className="row" dangerouslySetInnerHTML={{ __html: subScenario.descHTML }} />
      </div>
      <div className="thumb-up">
        <Thumb.Up isActive={scenarioService.subScenarioColl.isChecked(subScenario.id)} />
      </div>
    </S.ScenarioCard>
  )
}

export default observer(SubScenarioCard)

const S = {
  ScenarioCard: styled.div`
    position: relative;

    width: 260px;
    height: 126px;

    background: url(${s3URL.mathflatAssetsBucket.teacher('images/scenario/sub_scenario_bg.png')})
      #ffffff;
    background-position: top right;
    background-size: 147px 114px;
    background-repeat: no-repeat;

    border: 1px solid ${colors.subYellow};
    ${elevation.$03};
    border-radius: var(--Radius-200);
    ${typo.caption01};

    cursor: pointer;
    .inner {
      display: flex;
      flex-direction: column;

      padding: 15px 18px;

      width: 180px;
      height: 100%;
    }
    .row {
      word-break: keep-all;
    }
    .row + .row {
      margin-top: 4px;
    }

    .thumb-up {
      position: absolute;
      top: 17px;
      right: 17px;
    }
  `,
}
